<template>
  <div class="design-dashboard">
    <front-page-design-nav theme="light" />

    <section class="hero">
      <div class="hero__intro">
        <img :src="logo" alt="BOX21" class="hero__logo" />
        <h1>{{ hero.line1 }}</h1>
        <p>{{ hero.line2 }} {{ hero.line3 }}</p>
        <button type="button" class="hero__cta" @click="goToRegister">Open BOX21</button>
      </div>

      <div class="mock-ui">
        <div class="mock-ui__chrome">
          <span /><span /><span />
          <span class="mock-ui__url">box21.ai/projects</span>
        </div>
        <div class="mock-ui__body">
          <aside class="mock-sidebar">
            <div class="mock-sidebar__logo">
              <img :src="logo" alt="BOX21" height="24" />
            </div>
            <div v-for="item in sidebarItems" :key="item" class="mock-sidebar__item">{{ item }}</div>
          </aside>
          <main class="mock-main">
            <div class="mock-main__header">
              <h2>Wildlife Camera Project</h2>
              <span class="mock-badge">847 assets</span>
            </div>
            <div class="mock-grid">
              <div v-for="n in 6" :key="n" class="mock-thumb">
                <div class="mock-thumb__box" />
                <span class="mock-thumb__label">deer_{{ n }}.jpg</span>
              </div>
            </div>
            <div class="mock-stats">
              <div v-for="stat in stats" :key="stat.label" class="mock-stat">
                <span class="mock-stat__val">{{ stat.value }}</span>
                <span class="mock-stat__label">{{ stat.label }}</span>
              </div>
            </div>
          </main>
        </div>
      </div>
    </section>

    <section class="features">
      <article v-for="pillar in pillars" :key="pillar.id">
        <img :src="pillar.icon" :alt="pillar.title" />
        <h3>{{ pillar.title }}</h3>
      </article>
    </section>

    <front-page-design-footer theme="light" />
  </div>
</template>

<script>
import FrontPageDesignNav from '@/components/front_page/designs/FrontPageDesignNav.vue'
import FrontPageDesignFooter from '@/components/front_page/designs/FrontPageDesignFooter.vue'
import { BRAND, HERO, PILLARS } from '@/components/front_page/designs/shared'

export default {
  name: 'DesignDashboard',
  components: { FrontPageDesignNav, FrontPageDesignFooter },
  data() {
    return {
      logo: BRAND.logo,
      hero: HERO,
      pillars: PILLARS,
      sidebarItems: ['Projects', 'Annotate', 'My Assets', 'Models', 'Train'],
      stats: [
        { value: '94%', label: 'mAP' },
        { value: '12', label: 'Labels' },
        { value: '3', label: 'Models' },
      ],
    }
  },
  methods: {
    goToRegister() { this.$router.push({ path: '/login', query: { tab: 'register' } }) },
  },
}
</script>

<style scoped>
.design-dashboard {
  min-height: 100vh;
  background: linear-gradient(180deg, #eef5fa 0%, #fff 40%);
  font-family: system-ui, sans-serif;
  color: #333;
}

.hero {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 64px;
}

.hero__intro {
  text-align: center;
  max-width: 520px;
  margin: 0 auto 48px;
}

.hero__logo {
  height: 40px;
  margin-bottom: 20px;
}

.hero__intro h1 {
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 800;
  color: #0677b9;
  margin: 0 0 12px;
}

.hero__intro p {
  color: #666;
  margin: 0 0 24px;
  line-height: 1.6;
}

.hero__cta {
  background: #0677b9;
  color: #fff;
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.mock-ui {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 32px 64px rgba(6, 119, 185, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
  background: #fff;
}

.mock-ui__chrome {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f0f0f0;
  border-bottom: 1px solid #ddd;
}

.mock-ui__chrome span:first-child,
.mock-ui__chrome span:nth-child(2),
.mock-ui__chrome span:nth-child(3) {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ccc;
}

.mock-ui__url {
  margin-left: 16px !important;
  width: auto !important;
  height: auto !important;
  background: #fff !important;
  border-radius: 6px !important;
  padding: 4px 16px !important;
  font-size: 0.8rem;
  color: #888;
}

.mock-ui__body {
  display: grid;
  grid-template-columns: 180px 1fr;
  min-height: 360px;
}

.mock-sidebar {
  background: #f5f5f5;
  border-right: 1px solid #e0e0e0;
  padding: 16px 0;
}

.mock-sidebar__logo {
  padding: 0 16px 16px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 8px;
}

.mock-sidebar__item {
  padding: 10px 16px;
  font-size: 0.85rem;
  color: #555;
}

.mock-sidebar__item:first-of-type {
  background: rgba(6, 119, 185, 0.1);
  color: #0677b9;
  font-weight: 600;
}

.mock-main {
  padding: 20px 24px;
}

.mock-main__header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.mock-main__header h2 {
  font-size: 1.1rem;
  margin: 0;
}

.mock-badge {
  font-size: 0.75rem;
  background: #eef5fa;
  color: #0677b9;
  padding: 4px 10px;
  border-radius: 999px;
}

.mock-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

.mock-thumb {
  aspect-ratio: 4/3;
  background: #f0f0f0;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.mock-thumb__box {
  position: absolute;
  top: 20%;
  left: 25%;
  width: 40%;
  height: 50%;
  border: 2px solid #0677b9;
  border-radius: 2px;
}

.mock-thumb__label {
  position: absolute;
  bottom: 6px;
  left: 8px;
  font-size: 0.65rem;
  color: #888;
}

.mock-stats {
  display: flex;
  gap: 24px;
}

.mock-stat__val {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0677b9;
}

.mock-stat__label {
  font-size: 0.75rem;
  color: #888;
}

.features {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  max-width: 1000px;
  margin: 0 auto;
  padding: 48px 24px 80px;
  text-align: center;
}

.features img {
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
}

.features h3 {
  font-size: 0.95rem;
  margin: 0;
}

@media (max-width: 768px) {
  .mock-ui__body {
    grid-template-columns: 1fr;
  }
  .mock-sidebar {
    display: none;
  }
  .features {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
